import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { FornecedorEditarComponent } from "./fornecedor-editar.component";
import { FornecedorEditarRoutingModule } from "./fornecedor-editar-routing.module";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { TooltipModule } from "primeng/tooltip";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from "primeng/progressspinner";



@NgModule({
    imports: [
        CommonModule,            
        FornecedorEditarRoutingModule,
        FormsModule,
        TableModule,      
        ButtonModule,
        InputTextModule,
        TooltipModule,
        DropdownModule,
        InputMaskModule,
        MessagesModule,
        ProgressSpinnerModule

    ],
    declarations: [FornecedorEditarComponent]
})
export class FornecedorEditarModule { }
